export const DEFAULT_AUTO_PLAY_INTERVAL = 5;
export const MIN_AUTO_PLAY_INTERVAL = 3;
export const MAX_AUTO_PLAY_INTERVAL = 15;
export const MIN_RANGE_GAP = 1;
export const SCHEMA_VERSION = 4;
export const MAX_VISIBLE_TOASTS = 3;
export const TOAST_DURATIONS: Record<string, number> = {
  success: 3000,
  info: 4000,
  warning: 5000,
  error: 6000,
};
export const MANIFEST_RETRY_COUNT = 3;
export const MANIFEST_RETRY_BASE_DELAY = 1000;
export const AUDIO_STALL_TIMEOUT = 15000;
/** Min/max seconds before Skip Audio button becomes clickable. */
export const MIN_SKIP_AUDIO_THRESHOLD = 0;
export const MAX_SKIP_AUDIO_THRESHOLD = 60;
export const CONSECUTIVE_FAILURE_LIMIT = 3;
export const DEBOUNCE_SAVE_DELAY = 500;
export const MAX_PRELOAD_FAST = 3;
export const MAX_PRELOAD_MEDIUM = 2;
export const MAX_PRELOAD_SLOW = 1;
